import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { State } from './state';
import { environment } from '../environments/environment';
import {FamilyService} from './family';
import {AppointmentService} from './appointment';
import {TeamService} from './teamService';
import {ServiceLevelService} from './service-level-service';


@Injectable({
  providedIn: 'root'
})
export class StateService {


    constructor(
      private familyService : FamilyService,
      private appointmentService : AppointmentService,
      private teamService : TeamService,
      private serviceLevelService : ServiceLevelService
    ) {
    }

  loadInitialState() {
    this.appointmentService.reset();

    this.serviceLevelService.getServiceLevels().subscribe(response => {
      State.setState({
        discriminator: 'serviceLevels',
        serviceLevels: response
      });
    });
    this.teamService.getTeamsForProvider().subscribe(response => {

      State.setState({
        discriminator: 'teams',
        teams: response
      });
      this.familyService.getFamilyList().subscribe(response => {
        State.setState({
          discriminator: 'familyList',
          familyList: response
        });
      })
    });



  }
  }
